export const PAHT_BY_PLACE = {
    渋谷: "/class/place/shibuya.html",
    新宿: "/class/place/shinjuku.html",
    池袋: "/class/place/ikebukuro.html",
    高田馬場: "/class/place/takadanobaba.html",
    横浜: "/class/place/yokohama.html",
    関内: "/class/place/yokohama.html",
    大宮: "/class/place/omiya.html",
    難波: "/class/place/osaka.html",
    大阪心斎橋: "/class/place/osaka.html",
    大阪梅田: "/class/place/osaka.html",
};
